import { getDistanceBetweenTwoPointsInKm } from "./getDistanceBetweenTwoPointsInKm";

export function isInRange([lat1, lon1], [lat2, lon2], km) {
  return getDistanceBetweenTwoPointsInKm(lat1, lon1, lat2, lon2) <= km;
}
